const video = {
  methods: {
    getVideoDuration (file) {
      return new Promise((resolve, reject) => {
        const video = document.createElement('video')
        const url = URL.createObjectURL(file)

        video.addEventListener('loadedmetadata', () => {
          URL.revokeObjectURL(url)
          resolve(video.duration)
        })

        video.addEventListener('error', (err) => {
          URL.revokeObjectURL(url)
          reject(err)
        })

        video.src = url
      })
    },
    // 获取视频缩略图
    generateVideoThumbnail (file) {
      return new Promise((resolve, reject) => {
        const video = document.createElement('video')

        video.onloadeddata = () => {
          video.currentTime = 1
          video.crossorigin = 'anonymous'
          // 使用 onseeked 确保在指定时间点渲染后获取帧
          video.onseeked = () => {
            const canvas = document.createElement('canvas')
            canvas.width = video.videoWidth
            canvas.height = video.videoHeight

            const ctx = canvas.getContext('2d')
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height)

            // 转换为 base64
            const thumbnail = canvas.toDataURL('image/jpeg', 0.7)
            resolve(thumbnail)
          }
        }

        video.onerror = (error) => {
          reject(error)
        }

        // video.crossOrigin = 'anonymous'
        video.src = URL.createObjectURL(file)
      })
    },
    // base64 转 File 对象
    base64ToFile (base64String, filename = 'thumbnail.jpg') {
      try {
        // 去掉base64前缀
        const base64Data = base64String.replace(/^data:image\/\w+;base64,/, '')

        // 解码base64
        const byteString = atob(base64Data)

        // 获取MIME类型
        const mimeMatch = base64String.match(/^data:(.*?);base64/)
        const mimeString = mimeMatch ? mimeMatch[1] : 'image/jpeg'

        // 创建字节数组
        const ab = new ArrayBuffer(byteString.length)
        const ia = new Uint8Array(ab)

        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i)
        }

        // 创建File对象
        return new File([ab], filename, { type: mimeString })
      } catch (error) {
        console.error('转换base64到File失败:', error)
        return null
      }
    },
    // 获取视频缩略图并转换为File对象
    async getVideoThumbnailAsFile (file, filename = 'video_thumbnail.jpg') {
      try {
        const thumbnailBase64 = await this.generateVideoThumbnail(file)
        const thumbnailFile = this.base64ToFile(thumbnailBase64, filename)
        return {
          base64: thumbnailBase64,
          file: thumbnailFile
        }
      } catch (error) {
        console.error('获取视频缩略图失败:', error)
        return null
      }
    },
    isVideoFile (file) {
      if (!file) return false
      if (file.type) {
        const videoTypes = [
          'video/mp4',
          'video/webm',
          'video/ogg'
        ]

        if (videoTypes.includes(file.type)) {
          return true
        }
      }
    }
  }
}

export default video
